import { render, staticRenderFns } from "./soanNhomCongViec.vue?vue&type=template&id=37a03a24&scoped=true&"
import script from "./soanNhomCongViec.vue?vue&type=script&lang=js&"
export * from "./soanNhomCongViec.vue?vue&type=script&lang=js&"
import style0 from "./soanNhomCongViec.vue?vue&type=style&index=0&id=37a03a24&scoped=true&lang=css&"
import style1 from "./soanNhomCongViec.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a03a24",
  null
  
)

export default component.exports